import { Flex, Text } from "@chakra-ui/react";

interface PriceAndStrikePriceLabelProps {
  price?: number | string;
  strokePrice?: number | string;
  isOnSale?: boolean;
  fontSize?: string | Record<string, string> | number;
  displayAsAColumn?: boolean;
  priceColor?: string;
  strokeColor?: string;
  showIncludedLabel?: boolean;
}

export function PriceAndStrikePriceLabel({
  price,
  strokePrice,
  isOnSale = false,
  fontSize,
  displayAsAColumn = false,
  priceColor,
  strokeColor = "charcoal.200",
  showIncludedLabel = false,
}: PriceAndStrikePriceLabelProps) {
  // Default price color logic
  const defaultPriceColor = isOnSale ? "green.500" : "blaze.blaze";
  const finalPriceColor = priceColor || defaultPriceColor;

  // Format price display - handle both string and number inputs
  const formatPrice = (value?: number | string) => {
    if (!value) return "";
    if (typeof value === "string") {
      return value; // Bundle prices already come with $ symbol
    }
    return `$${value}`;
  };

  return (
    <Flex
      flexDirection={displayAsAColumn ? "column" : "row"}
      alignItems={displayAsAColumn ? "flex-start" : "center"}
      gap={displayAsAColumn ? "0" : "4px"}
    >
      <Text
        variant="releasePriceLabel"
        fontSize={fontSize}
        color={finalPriceColor}
      >
        {showIncludedLabel ? "Included" : formatPrice(price)}
      </Text>
      <Text
        fontSize={fontSize}
        variant="releasePriceLabel"
        color={strokeColor}
        textDecorationLine="line-through"
      >
        {formatPrice(strokePrice)}
      </Text>
    </Flex>
  );
}
